<div class="error-screen-elink"> 
    <div class="pe-circle">
        <div class="pe-top">
            <div class="login-pharma-img">
                <span *ngIf="pharmacyLogo"><img alt="Pharmacy" [src]="pharmacyLogo" class="phrmaLogo-bg"></span>
                <span>{{pharmacyInfo?.name}}</span>
                <p *ngIf="pharmacyInfo?.phone">Ph: {{pharmacyInfo?.phone | pharmNumberformat}}</p>
            </div>
            <div class="pe-Error-body"> 
                <div class="pe-err-img"> 
                    <img alt="Link Invalid" *ngIf="status === 0" class="error_circle" src="../assets/images/opps_invalid.png">
                    <img alt="Link Expired" *ngIf="status === 2" class="error_poly" src="../assets/images/opps_expired.png">
                </div>
                <div class="pe-error-msg" [ngStyle]="{'width':error_txt ? '100%' : '100%' }">{{errorMessage}}<br>
                    <span class="pe-error-sub" [ngStyle]="{'width':error_txt ? '100%' : '100%' }">{{common_msg}} <a href="tel:{{PharmacyPhoneNumber}}" class="pharma_number">{{pharmacyInfo?.phone | pharmNumberformat}}</a> </span></div>
                </div> 
        </div>
    </div>
</div>